import {
    FeedbacksTableData,
    FeedbacksTableFiltersApi,
} from '@/components/feedbacks-table/feedbacks-table-columns.types';
import {
    AiIcon,
    AnswerTextIcon,
    CameraIcon,
    ClearFilterButton,
    PresenceFilterIconButton,
    ReviewTextIcon,
    SearchIcon,
    UserIcon,
} from '@/components/feedbacks-table/feedbacks-table-columns.filters.shared';
import Input from '@/ui/Input';

export const renderTextFilterByColumn = (columnKey: keyof FeedbacksTableData, filters: FeedbacksTableFiltersApi) => {
    const {
        hasPhotos,
        hasAuthor,
        hasReviewText,
        hasAnswerText,
        hasAiResponse,
        reviewText,
        answerText,
        setHasPhotos,
        setHasAuthor,
        setHasReviewText,
        setHasAnswerText,
        setHasAiResponse,
        setReviewText,
        setAnswerText,
    } = filters;

    switch (columnKey) {
        case 'text':
            return (
                <div className="flex h-[34px] w-full min-w-0 items-center gap-1">
                    <div className="flex h-[34px] shrink-0 items-center gap-1">
                        <PresenceFilterIconButton
                            ariaLabel="Фильтр фото"
                            icon={<CameraIcon />}
                            value={hasPhotos}
                            onChange={setHasPhotos}
                        />
                        <PresenceFilterIconButton
                            ariaLabel="Фильтр автора"
                            icon={<UserIcon />}
                            value={hasAuthor}
                            onChange={setHasAuthor}
                        />
                        <PresenceFilterIconButton
                            ariaLabel="Фильтр текста отзыва"
                            icon={<ReviewTextIcon />}
                            value={hasReviewText}
                            onChange={setHasReviewText}
                        />
                    </div>
                    <div className="flex h-[34px] min-w-0 flex-1 items-center gap-1">
                        <div className="relative h-[34px] min-w-0 flex-1">
                            <Input
                                id="reviews-table-filter-review-text"
                                aria-label="Фильтр текста отзыва"
                                placeholder="Поиск"
                                value={reviewText}
                                onChange={(event) => setReviewText((event.target as HTMLInputElement).value)}
                                uiSize="compact"
                                className="h-[34px] min-h-[34px] min-w-0 w-full bg-white pr-8"
                            />
                            <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
                                <SearchIcon />
                            </div>
                        </div>
                        {reviewText && (
                            <ClearFilterButton ariaLabel="Очистить фильтр отзыва" onClick={() => setReviewText('')} />
                        )}
                    </div>
                </div>
            );
        case 'answer':
            return (
                <div className="flex h-[34px] w-full min-w-0 items-center gap-1">
                    <PresenceFilterIconButton
                        ariaLabel="Фильтр текста ответа"
                        icon={<AnswerTextIcon />}
                        value={hasAnswerText}
                        onChange={setHasAnswerText}
                    />
                    <div className="relative h-[34px] min-w-0 flex-1">
                        <Input
                            id="reviews-table-filter-answer-text"
                            aria-label="Фильтр текста ответа"
                            placeholder="Поиск"
                            value={answerText}
                            onChange={(event) => setAnswerText((event.target as HTMLInputElement).value)}
                            uiSize="compact"
                            className="h-[34px] min-h-[34px] min-w-0 w-full bg-white pr-8"
                        />
                        <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
                            <SearchIcon />
                        </div>
                    </div>
                    {answerText && (
                        <ClearFilterButton ariaLabel="Очистить фильтр ответа" onClick={() => setAnswerText('')} />
                    )}
                </div>
            );
        case 'aiApiResponse':
            return (
                <div className="flex h-[34px] w-[44px] min-w-0 items-center justify-center">
                    <PresenceFilterIconButton
                        ariaLabel="Фильтр AI-анализа"
                        icon={<AiIcon />}
                        value={hasAiResponse}
                        onChange={setHasAiResponse}
                    />
                </div>
            );
        default:
            return null;
    }
};
